import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_07 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_07.webp'
import { useEffect } from 'react';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import imgHANSA_FLEX_BRANCH_SERBIA_VALJEVO from '../../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_VALJEVO.webp'
import imgvaljevo1 from '../../../assets/Branch/valjevo/valjevo1.jpg'
import imgvaljevo2 from '../../../assets/Branch/valjevo/valjevo2.jpg'
import imgvaljevo3 from '../../../assets/Branch/Cylinder/Cylinder2.jpg'
import imgvaljevo4 from '../../../assets/Branch/Cylinder/Cylinder5.jpg'
import imgvaljevo5 from '../../../assets/Branch/Cylinder/Cylinder6.jpg'


const Branch7 = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [
        {
            image: imgvaljevo3,
        },
        {
            image: imgvaljevo1,
        },
        {
            image: imgvaljevo4,
        },
        {
            image: imgvaljevo2,
        },
        {
            image: imgvaljevo5,
        },
    ]

    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX_BRANCH_SERBIA_VALJEVO} title={"Welcome to HANSA-FLEX Valjevo"} paragraph={"Opened in 2022 with the intention to be closer to the customers from Western Serbia, branch Valjevo has very quickly attracted many customers from different fields, from construction, services, factories and many others. Just like the larger branches, this smaller one can fully service any customer whatever the problem is."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />

            <ThreeDImageCarousel items={carouselData} />


            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>


        </div>
    )
}

export default Branch7